import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Link from '../link/internal-link';
import styles from './text-editor-hashtag.scss';

const Hashtag = ({ children, decoratedText, createHref, theme }) => {
  const to = createHref(decoratedText.slice(1));
  const Component = to ? Link : 'span';
  const props = to ? { className: classNames(theme, styles.hover), to } : { className: theme };

  return (
    <Component {...props}>
      {children}
    </Component>
  );
};

Hashtag.propTypes = {
  children: PropTypes.node,
  decoratedText: PropTypes.string,
  createHref: PropTypes.func,
  theme: PropTypes.string,
};

Hashtag.defaultProps = {
  createHref: () => {},
};

export default Hashtag;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-hashtag.js